/**
 * Sysadmin catalog agent builder route — thin wrapper around
 * <AgentBuilder scope="sysadmin">.
 *
 * Phase 4 of PR-A AgentBuilder shared-component refactor (2026-05-11).
 * The entire builder body lives in
 * `@/components/agent-builder-shared/AgentBuilder.tsx`. This file only
 * declares the TanStack-Router file route + parses the `?id=` (edit
 * mode) and `?model=` (preselect) query params. ALL canvas, conversation,
 * save, mutation, lifecycle, and slug-derive logic is shared with the
 * tenant builder route.
 *
 * Sysadmin-specific affordances (lifecycle action bar, slug field,
 * functions/workflows pickers enabled, "Editing system agent" subtitle,
 * 10 sections) are gated via the sysadminAdapter — see
 * `AgentBuilder.types.ts` and `AgentBuilder.adapters.tsx` for the
 * canonical scope-deviation table.
 */
import { createFileRoute } from '@tanstack/react-router';
import { AgentBuilder } from '@/components/agent-builder-shared/AgentBuilder';

// `?id=<agentId>` puts the builder in EDIT mode (PATCH instead of POST).
// `?model=<modelId>` pre-selects an Argus model UUID for new agents.
export const Route = createFileRoute('/sysadmin/catalog/agents/builder')({
  validateSearch: (search: Record<string, unknown>) => ({
    id: typeof search.id === 'string' ? search.id : undefined,
    model: typeof search.model === 'string' ? search.model : undefined,
  }),
  component: SysadminAgentBuilderRoute,
});

function SysadminAgentBuilderRoute() {
  const { id, model: preselectModel } = Route.useSearch();
  return <AgentBuilder scope="sysadmin" agentId={id} preselectModel={preselectModel} />;
}
